import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import {
  DROPDOWN_MENU_CONTENT_DEFAULTS,
  type TDropdownMenuContentElement,
  type TDropdownMenuContentProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { cn } from "@/ui/lib/utils";

export const DropdownMenuContent = forwardRef<TDropdownMenuContentElement, TDropdownMenuContentProps>(
  (
    {
      className,
      align = DROPDOWN_MENU_CONTENT_DEFAULTS.align,
      sideOffset = DROPDOWN_MENU_CONTENT_DEFAULTS.sideOffset,
      ...props
    },
    ref,
  ) => (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        data-component="DropdownMenuContent"
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 min-w-32 overflow-hidden rounded-sys-sm border border-solid border-component-input-default bg-component-input-focused p-1 shadow-md",
          "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
          "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
          "data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className,
        )}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  ),
);

DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
